import { useState, useRef, useEffect } from 'react';
import { useUnmount } from 'react-use';

const useTriggeredTooltip = function () {
  let closeTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
  const [opened, setOpened] = useState(false);
  const [triggered, setTriggered] = useState(false);
  const timeout = useRef();
  const resetTooltip = () => {
    setTriggered(false);
    setOpened(false);
    timeout.current && clearTimeout(timeout.current);
  };
  const onClick = () => {
    setOpened(true);
    setTriggered(true);
    timeout.current && clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      resetTooltip();
    }, closeTimeout);
  };
  const onMouseEnter = () => {
    setTriggered(false);
    setOpened(true);
    timeout.current && clearTimeout(timeout.current);
  };
  const onMouseLeave = () => {
    resetTooltip();
  };
  const onClickOutside = () => {
    resetTooltip();
  };
  useUnmount(() => {
    timeout.current && clearTimeout(timeout.current);
  });
  return {
    triggerProps: {
      onClick,
      onMouseEnter,
      onMouseLeave
    },
    opened,
    triggered,
    setOpened,
    onClickOutside
  };
};
const useHoverableTooltip = ref => {
  const [opened, setOpened] = useState(false);
  useEffect(() => {
    const handleMouseEnter = () => setOpened(true);
    const handleMouseLeave = () => setOpened(false);
    const tooltipElement = ref.current;
    if (tooltipElement) {
      tooltipElement.addEventListener('mouseenter', handleMouseEnter);
      tooltipElement.addEventListener('mouseleave', handleMouseLeave);
    }
    return () => {
      if (tooltipElement) {
        tooltipElement.removeEventListener('mouseenter', handleMouseEnter);
        tooltipElement.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [ref]);
  return {
    opened
  };
};

export { useHoverableTooltip, useTriggeredTooltip };
//# sourceMappingURL=useTooltip.js.map
